// Copyright (c) Docugami, Inc. All rights reserved.

import React, { useState, useEffect } from "react";
import { useDrop } from "react-dnd";
import styled from "styled-components";
import { DndItem, DropTypes } from "./DndTypes"

const targetHeight = 3;
const activeTargetHeight = 40;

const Root = styled.div`
    position: relative;
`;

const AbsoluteTarget = styled.div<{ height: number }>`
    position: absolute;
    height: ${props => `${props.height + 25}px`};
    top: -20px;
    left: 0;
    width: 100%;
`;

const DropTarget = styled.div<{ height: number }>`
    height: ${props => `${props.height}px`};
    transition: height 0.3s ease-in-out 0.1s;
`;

export interface DndListDropTargetProps {
    show?: boolean;
    dropTypes: DropTypes;
    onDrop?: (item: DndItem) => void;
    renderPreview?: (dndItem: DndItem) => React.ReactNode;
}

export const DndListDropTarget = (props: DndListDropTargetProps) => {
    const [height, setHeight] = useState(!!props.show ? targetHeight : 0);

    const [, dropRef] = useDrop(() => ({
        accept: props.dropTypes,
        canDrop: (item, m) => !!props.onDrop && m.isOver({ shallow: true }),
        drop: (item) => {
            props.onDrop?.(item as DndItem);
        },
    }));

    useEffect(() => {
        setHeight(!!props.show ? targetHeight : 0);
    }, [props.show])

    return (
        <Root onDragEnter={() => setHeight(activeTargetHeight)} onDragLeave={() => setHeight(targetHeight)}>
            <DropTarget height={height} />
            {!!props.show && <AbsoluteTarget height={height} ref={dropRef} />}
        </Root>
    )
}